const api = require("./api");

export default function Auth(login, password) {
	return api({
		url:    "/auth",
		method: "post",
		data:   {
			login: login,
			pass:  password
		}
	});
}

